import { useQuery } from '@apollo/client';
import gql from 'graphql-tag';
import { BSON } from 'realm-web';
import { useRealmApp } from '../RealmApp';

const useRootUser = () => {
  const app = useRealmApp();
  const { rootUser, loading } = useAllRootUser(app.currentUser.id);
  return {
    loading,
    rootUser,
  };
};

function useAllRootUser(id) {
  //
  const { data, loading, error } = useQuery(
    gql`
      query getRootUser($_id: ObjectId!) {
        rootUser(query: { _id: $_id }) {
          _id
          address1
          address2
          city
          color
          country
          email
          emailConfirmed
          idNumber
          image
          language
          lastName
          name
          phone
          phone2
          qrData
          updateDatetime
          creationDatetime
        }
      }
    `,
    { variables: { _id: new BSON.ObjectId(id) } }
  );
  if (error) {
    throw new Error(`Failed to fetch tasks: ${error.message}`);
  }
  // If the query has finished, return the tasks from the result data
  // Otherwise, return an empty list
  const rootUser = data?.rootUser ?? [];
  return { rootUser, loading };
}

export default useRootUser;
